import {createRouterRedirectCallback} from '@sollapay/web-core';
import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';

import App from './app/App';
import {Providers} from './app/Providers';
import {initSentry} from './app/sentry';
import './index.css';
import {router} from './lib/router';
import {logAppBanner} from './utils/log-app-banner.utils';

initSentry();

logAppBanner();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <Providers onAuthRedirectCallback={createRouterRedirectCallback(router.navigate)}>
      <App />
    </Providers>
  </StrictMode>
);
